import * as actionTypes from '../constants/actionTypes';
export default function hasLoadedExternalPrototypeReducer(state, action) {
    if (state === void 0) { state = 'pending'; }
    switch (action.type) {
        case actionTypes.EXTERNAL_PROTOTYPE_LOADING:
            return 'loading';
        case actionTypes.EXTERNAL_PROTOTYPE_LOADED:
            return 'loaded';
        default:
            return state;
    }
}
